import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _isEqual from 'lodash/isEqual';
import _isNull from 'lodash/isNull';
import _has from 'lodash/has';
import cn from 'classnames';
import TextCropper from '@omilia/text-cropper';
import Highlighter from 'react-highlight-words';
import { colors } from '@omilia/theme';

import { ruleType } from 'types';
import ArchivedIcon from 'components/SelectableList/components/ArchivedIcon';
import RuleHOC from '../RuleHOC';
import Warning from './components/Warning';
import Icons from './components/Icons';

import './style.scss';

export class RuleItem extends Component {
  static propTypes = {
    isPreSelected: PropTypes.bool.isRequired,
    isSelected: PropTypes.bool.isRequired,
    model: ruleType.isRequired,
    canDrop: PropTypes.bool,
    className: PropTypes.string,
    getRuleMatchedRows: PropTypes.func,
    isArchived: PropTypes.bool,
    isDragging: PropTypes.bool,
    isGrouped: PropTypes.bool,
    isOver: PropTypes.bool,
    matchedRulesMap: PropTypes.shape({}),
    number: PropTypes.node,
    reorder: PropTypes.node,
    searchTerm: PropTypes.string,
    selectGroupItem: PropTypes.func,
    statusChange: PropTypes.func,
    onOpenDuplicateModal: PropTypes.func,
  };

  static defaultProps = {
    className: '',
    isGrouped: false,
  };

  state = {
    isHovered: false,
  };

  componentWillReceiveProps(nextProps) {
    const { isSelected } = this.props;
    const { isHovered } = this.state;

    if (nextProps.isSelected !== isSelected && isHovered) {
      this.setState({
        isHovered: false,
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.isSelected !== nextProps.isSelected ||
      this.props.isPreSelected !== nextProps.isPreSelected ||
      this.state.isHovered !== nextState.isHovered ||
      this.props.isDragging !== nextProps.isDragging ||
      this.props.isOver !== nextProps.isOver ||
      this.props.canDrop !== nextProps.canDrop ||
      !_isEqual(nextProps.model, this.props.model) ||
      !_isEqual(nextProps.reorder, this.props.reorder) ||
      !_isEqual(nextProps.number, this.props.number)
    );
  }

  getMatchedRowsArray = () => {
    const { model, getRuleMatchedRows, matchedRulesMap } = this.props;
    const rows = getRuleMatchedRows(model, matchedRulesMap);

    return rows || [];
  };

  handleMouseEnter = () => {
    const { isSelected, isDragging } = this.props;
    if (!isSelected && !isDragging) {
      this.setState({
        isHovered: true,
      });
    }
  };

  handleMouseLeave = () => {
    const { isSelected, isDragging } = this.props;
    if (!isSelected && !isDragging) {
      this.setState({
        isHovered: false,
      });
    }
  };

  handleClick = e => {
    const { model, selectGroupItem, isGrouped } = this.props;
    if (_has(model, 'rule_group') && isGrouped) {
      e.stopPropagation();
      selectGroupItem(model);
    }
  };

  handleDuplicate = e => {
    const { onOpenDuplicateModal, model, isGrouped } = this.props;
    e.stopPropagation();

    onOpenDuplicateModal(model, isGrouped);
  };

  handleRefWrap = reorder => {
    this.reorder = reorder;
  };

  renderRowComma = (i, arr) => (i !== arr.length - 1 ? ',' : '');

  /* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
  renderRows() {
    const matchedRows = this.getMatchedRowsArray();

    if (matchedRows.length > 0) {
      return (
        <div data-test="rows" styleName="rows">
          <span>IN ROWS</span>
          <div data-test="numb" styleName="numb">
            {matchedRows.map((item, i, arr) => (
              <span key={item}>
                {item + 1}
                {this.renderRowComma(i, arr)}
              </span>
            ))}
          </div>
        </div>
      );
    }

    return null;
  }

  render() {
    const {
      className,
      isArchived,
      isSelected,
      isPreSelected,
      reorder,
      number,
      statusChange,
      isDragging,
      isOver,
      canDrop,
      searchTerm,
      // eslint-disable-next-line camelcase
      model: { actions, matching_pattern_elements, enabled, name, xpack },
    } = this.props;
    const { isHovered } = this.state;

    return (
      <div
        ref={this.handleRefWrap}
        className={className}
        styleName={cn('item', {
          'is-archived': isArchived,
          'is-disabled': !enabled,
          'is-pre-selected': isPreSelected || isHovered,
          'is-selected': isSelected,
          'is-dragging': isDragging,
          'is-over': isOver && canDrop && !isDragging,
          // 'not-dropped': isOver && !canDrop,
        })}
        onClick={this.handleClick}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div styleName="item__name__block">
          {number}
          <div data-test="rule-name" styleName="crooper-container">
            <TextCropper styleName="name">
              <Highlighter
                autoEscape
                highlightClassName="text-highlighter"
                highlightStyle={{ color: colors.COLOR_GREY_900 }}
                highlightTag="strong"
                searchWords={[searchTerm?.trim()]}
                textToHighlight={name}
              />
            </TextCropper>
          </div>
          {!_isNull(xpack) && xpack ? <sup data-test="xp">XP</sup> : null}
        </div>
        {this.renderRows()}
        <div styleName="item__icons">
          {!isArchived && (isSelected || isHovered || isDragging) && (
            <Icons
              enabled={enabled}
              onDuplicate={this.handleDuplicate}
              onStatusChange={statusChange}
            />
          )}
          {isArchived && <ArchivedIcon name="Rule" />}
          {(actions.length === 0 || matching_pattern_elements.length === 0) && (
            <Warning />
          )}
        </div>
        {reorder}
      </div>
    );
  }
}

export default RuleHOC(RuleItem);
